import { gql } from '@apollo/client';

import { MeetingPlacePageEventItemFragment } from '../fragments/meetingPlacePageEventItem';
import { fetchAndMergeEventItemRichText } from './pageEventItemRichTextQuery';
import { TENANT_IDS_FROM_EVENT_FRAGMENT } from './getActiveEventIdsWithTenantIds';

export const MEETING_PLACE_PAGE_EVENT_QUERY = gql`
  ${MeetingPlacePageEventItemFragment}
  query MeetingPlacePageEventQuery($id: String!, $language: String!) {
    meetingPlacePageEvent(id: $id, locale: $language) {
      ...MeetingPlacePageEventItem
    }
  }
`;

export const MEETING_PLACE_PAGE_EVENT_SEO_QUERY = gql`
  query MeetingPlacePageEventSeoQuery(
    $id: String!
    $locale: String!
    $preview: Boolean
  ) {
    meetingPlacePageEvent(id: $id, locale: $locale, preview: $preview) {
      sys {
        id
        locale
      }
      name
      slug
      mediaField {
        jsonBynderAsset
        altText
      }
      body {
        json
      }
      seoDescription
      eventTypesCollection {
        items {
          ... on LibraryEventType {
            sys {
              id
            }
            name
          }
        }
      }
    }
  }
`;

export const GET_MATCHING_EVENTS = gql`
  ${TENANT_IDS_FROM_EVENT_FRAGMENT}
  query GetMatchingEvents($ids: [String!]!, $language: String!) {
    meetingPlacePageEventCollection(
      where: { sys: { id_in: $ids } }
      locale: $language
    ) {
      items {
        __typename
        sys {
          id
        }
    name
    slug
    startDate
    endDate
    hideInListFrom
    mediaField {
      jsonBynderAsset
      altText
    }
    eventTypesCollection {
      items {
        ... on LibraryEventType {
          sys {
            id
          }
          name
        }
        }
        }
          tenant{
       ...TenantIdsFromEvent
      }
      }
    }
  }
`;

/**
 * Fetches event page data with rich text body merged
 */
export async function getMeetingPlacePageEventData(
  id: string,
  locale: string,
  preview?: boolean,
) {
  const { getApolloClient } = await import('../apolloClient');
  const client = getApolloClient(preview);

  const { data }: any = await client.query({
    query: MEETING_PLACE_PAGE_EVENT_QUERY,
    variables: {
      id,
      language: locale,
    },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  const eventData = data?.meetingPlacePageEvent;

  if (!eventData) {
    return null;
  }

  // Fetch and merge rich text body for the event item
  const mergedEventData = await fetchAndMergeEventItemRichText(
    client,
    eventData,
    locale,
    preview,
  );

  console.log('Fetched event data with merged rich text:', mergedEventData);

  return mergedEventData;
}
